import { createSlice } from '@reduxjs/toolkit'

const appRefreshApiSlice = createSlice({
  name: 'appRefreshApi',
  initialState: {},
  reducers: {
    versionMismatched: () => {},
  },
})

const { reducer, actions: events } = appRefreshApiSlice

export { events, reducer }
